import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { adminApi } from "@/lib/adminAuth";
import { toast } from "sonner";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState("");
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/admin/users", { ...adminApi(), params: { q: q || undefined } }).then(({ data }) => setUsers(data));
  useEffect(() => { load(); }, []); // eslint-disable-line

  const save = async () => {
    try {
      await api.patch(`/admin/users/${editing.id}`, {
        tokens: parseInt(editing.tokens),
        is_premium: editing.is_premium,
        name: editing.name,
      }, adminApi());
      toast.success("Güncellendi");
      setEditing(null);
      load();
    } catch (e) { toast.error("Hata"); }
  };

  return (
    <div className="font-admin-body">
      <h1 className="font-admin-head text-3xl mb-6">Kullanıcılar</h1>
      <div className="flex gap-3 mb-4">
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="E-posta veya ad ara..." data-testid="users-search" className="admin-input max-w-sm" />
        <button onClick={load} data-testid="users-search-btn" className="admin-btn">Ara</button>
      </div>

      <div className="admin-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-xs text-white/50 uppercase tracking-wider">
            <tr className="border-b border-[#27272A]">
              <th className="p-3">Ad</th>
              <th className="p-3">E-posta</th>
              <th className="p-3">Jeton</th>
              <th className="p-3">Üyelik</th>
              <th className="p-3">Burç</th>
              <th className="p-3">Kayıt</th>
              <th className="p-3"></th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-b border-[#18181B] hover:bg-white/[0.02]">
                <td className="p-3">{u.name}</td>
                <td className="p-3 text-white/70">{u.email}</td>
                <td className="p-3 tabular-nums">{u.tokens}</td>
                <td className="p-3">{u.is_premium ? <span className="text-[#F59E0B]">Premium</span> : <span className="text-white/50">—</span>}</td>
                <td className="p-3">{u.zodiac_sign || "-"}</td>
                <td className="p-3 text-white/50 text-xs">{new Date(u.created_at).toLocaleDateString("tr-TR")}</td>
                <td className="p-3">
                  <button onClick={() => setEditing({ ...u })} data-testid={`edit-user-${u.id}`} className="admin-btn-ghost text-xs px-3 py-1">Düzenle</button>
                  <button onClick={async () => {
                    const pwd = window.prompt(`${u.email} için yeni şifre (boş bırakırsan otomatik):`);
                    if (pwd === null) return;
                    const finalPwd = pwd.trim() || (Math.random().toString(36).slice(-8) + Math.floor(Math.random()*10));
                    try {
                      const { data } = await api.post(`/admin/users/${u.id}/reset-password`, { new_password: finalPwd }, adminApi());
                      window.prompt("Yeni şifre (kopyala & kullanıcıya ilet):", data.new_password);
                    } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
                  }} data-testid={`reset-pwd-${u.id}`} className="admin-btn-ghost text-xs px-3 py-1 ml-1 text-amber-400">Şifre Sıfırla</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {editing && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4" data-testid="edit-user-modal">
          <div className="admin-card p-6 w-full max-w-md">
            <h2 className="font-admin-head text-xl mb-4">Kullanıcıyı Düzenle</h2>
            <div className="space-y-3">
              <div>
                <label className="text-xs text-white/50">Ad</label>
                <input value={editing.name} onChange={(e) => setEditing({ ...editing, name: e.target.value })} className="admin-input" />
              </div>
              <div>
                <label className="text-xs text-white/50">Jeton</label>
                <input type="number" value={editing.tokens} onChange={(e) => setEditing({ ...editing, tokens: e.target.value })} data-testid="edit-tokens-input" className="admin-input" />
              </div>
              <label className="flex items-center gap-2 text-sm">
                <input type="checkbox" checked={editing.is_premium} onChange={(e) => setEditing({ ...editing, is_premium: e.target.checked })} data-testid="edit-premium-checkbox" className="accent-[#F59E0B]" />
                Premium
              </label>
            </div>
            <div className="flex gap-2 mt-6">
              <button onClick={save} data-testid="edit-user-save" className="admin-btn flex-1">Kaydet</button>
              <button onClick={() => setEditing(null)} className="admin-btn-ghost flex-1">İptal</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
